import type { ExperimentConfig } from './types';
import { ExperimentVariantCount } from './variantConfig';

export const HYSA_REDESIGN_V2_EXPERIMENT = {
  id: 'bnk_1175_hysa_redesign_v2',
  paths: ['/banking/best/high-yield-online-savings-accounts'],
};

export const ACCOUNT_CREATION_ENTRYPOINTS_EXPERIMENT = {
  id: 'bnk_1148_account_creation_entrypoints',
  paths: ['/banking/best/money-market-accounts'],
  variantCount: ExperimentVariantCount.Four,
};

export const DYNAMIC_APY_IN_PAID_ROUNDUP_TITLE_EXPERIMENT = {
  id: 'bnk_1066_dynamic_apy_title_cd',
  paths: ['/banking/m/standout-cd-rates-2', '/banking/m/standout-cd-rates-3'],
};

export const BANKING_ASSESSMENT_FLOW_EXPERIMENT = {
  id: 'bnk_996_banking_assessment_flow',
  paths: [
    // '/banking/best/checking-accounts',
    // '/banking/best/free-checking-accounts',
    // '/banking/best/cd-rates',
    // '/banking/best/high-yield-online-savings-accounts',
    '/banking/best/online-checking-accounts',
  ],
};

export const CD_COMPARISON_EXPERIMENT = {
  id: 'bnk_1085_cd_comparison_feature',
  paths: ['/banking/best/cd-rates'],
};

export const TRAFFIC_ROUTING_TEST_STANDOUT_SAVINGS_14_EXPERIMENT = {
  id: 'bnk_1195_traffic_routing_test_standout_savings_14',
  paths: ['/banking/m/standout-online-savings-accounts-14'],
};

export const TRAFFIC_ROUTING_TEST_STANDOUT_PRODUCTS_EXPERIMENT = {
  id: 'bnk_1195_traffic_routing_test_standout_products',
  paths: ['/banking/m/standout-high-yield-savings-products'],
};

export const TRAFFIC_ROUTING_TEST_STANDOUT_DG_EXPERIMENT = {
  id: 'bnk_1195_traffic_routing_test_standout_dg',
  paths: ['/banking/m/9ejf83-standout-savings-accounts'],
};

export const TRAFFIC_ROUTING_TEST_NTV_EXPERIMENT = {
  id: 'bnk_1195_traffic_routing_test_ntv',
  paths: ['/banking/m/standout-high-yield-savings-accounts-ntv-3'],
};

export const STATIC_EXPERIMENTS: ExperimentConfig[] = [
  {
    name: HYSA_REDESIGN_V2_EXPERIMENT.id,
    paths: HYSA_REDESIGN_V2_EXPERIMENT.paths,
    variantCount: ExperimentVariantCount.Three,
  },
  {
    name: ACCOUNT_CREATION_ENTRYPOINTS_EXPERIMENT.id,
    paths: ACCOUNT_CREATION_ENTRYPOINTS_EXPERIMENT.paths,
    variantCount: ExperimentVariantCount.Four,
  },
  {
    name: DYNAMIC_APY_IN_PAID_ROUNDUP_TITLE_EXPERIMENT.id,
    paths: DYNAMIC_APY_IN_PAID_ROUNDUP_TITLE_EXPERIMENT.paths,
  },
  {
    name: BANKING_ASSESSMENT_FLOW_EXPERIMENT.id,
    paths: BANKING_ASSESSMENT_FLOW_EXPERIMENT.paths,
    variantCount: ExperimentVariantCount.Three,
  },
  {
    name: CD_COMPARISON_EXPERIMENT.id,
    paths: CD_COMPARISON_EXPERIMENT.paths,
  },
  {
    name: TRAFFIC_ROUTING_TEST_STANDOUT_SAVINGS_14_EXPERIMENT.id,
    paths: TRAFFIC_ROUTING_TEST_STANDOUT_SAVINGS_14_EXPERIMENT.paths,
  },
  {
    name: TRAFFIC_ROUTING_TEST_STANDOUT_PRODUCTS_EXPERIMENT.id,
    paths: TRAFFIC_ROUTING_TEST_STANDOUT_PRODUCTS_EXPERIMENT.paths,
  },
  {
    name: TRAFFIC_ROUTING_TEST_STANDOUT_DG_EXPERIMENT.id,
    paths: TRAFFIC_ROUTING_TEST_STANDOUT_DG_EXPERIMENT.paths,
  },
  {
    name: TRAFFIC_ROUTING_TEST_NTV_EXPERIMENT.id,
    paths: TRAFFIC_ROUTING_TEST_NTV_EXPERIMENT.paths,
  },
];

const pagesWithDuplicatedExperiments: { [page: string]: string[] } = {};

export const STATIC_EXPERIMENT_CONFIG = STATIC_EXPERIMENTS.reduce(
  (experimentConfig: Record<string, string>, experiment, index) => {
    const experimentPages = experiment.paths;

    experimentPages.forEach(experimentPage => {
      // Searching for duplicated experiments
      const existingExperimentOnPage = experimentConfig[experimentPage];
      if (existingExperimentOnPage) {
        if (!pagesWithDuplicatedExperiments[experimentPage]) {
          pagesWithDuplicatedExperiments[experimentPage] = [existingExperimentOnPage];
        }
        pagesWithDuplicatedExperiments[experimentPage].push(experiment.name);
      }
      // End searching for duplicated experiments

      experimentConfig[experimentPage] = experiment.name;
    });

    // Forcing failure if more than one static experiment per page is found
    if (
      index === STATIC_EXPERIMENTS.length - 1 &&
      Object.keys(pagesWithDuplicatedExperiments).length > 0
    ) {
      const errorFriendlyObject = Object.keys(pagesWithDuplicatedExperiments).reduce(
        (acc: Record<string, string>, key) => {
          acc[key] = pagesWithDuplicatedExperiments[key].join(' | ');
          return acc;
        },
        {},
      );
      throw new Error('There can only be one static experiment per page', {
        cause: JSON.stringify(errorFriendlyObject),
      });
    }

    return experimentConfig;
  },
  {},
);
